export enum TOOL_APP_TYPES {
    // please keep alphabetical order!
    banner = "banner",
    coffee = "coffee",
    cookie = "cookie",
    faq = "faq",
    legal = "legal",
    love = "love",
    page = "page",
    player = "player",
    pricing = "pricing",
    ticker = "ticker",
    timer = "timer",
}

// union of all possible enum values:
export type ToolAppTypes = `${TOOL_APP_TYPES}`;
